/** Engine-wide assets shipped with the app (not per-scenario). */
const SHARED_ASSETS_BASE = '/shared-assets';

export function sharedAssetUrl(filename: string): string {
  return `${SHARED_ASSETS_BASE}/${filename}`;
}

export const SHARED_ASSETS = {
  telephone: sharedAssetUrl('telephone.png'),
  /** Fond de l'écran profil (pseudo et couleur). */
  profileBackground: sharedAssetUrl('bg-couloir-ministere.jpg'),
  /** Fond de l'écran classement. */
  leaderboardBackground: sharedAssetUrl('bg-hall-accueil.jpg'),
} as const;
